import { inside } from "@turf/turf";
import { basePointLayerStyle } from "config/geometryStyles";
import { Map, GeoJSON, geoJSON, circle } from "leaflet";
import { memo, useEffect, useState } from "react";
import { MeasureImpact, MeasureConfLayer, MeasureConf } from "types/types";
import { getGeojsonFeature } from "utils/GeomanUtils";

interface Props {
  mapRef: Map;
  measureImpact: MeasureImpact;
  studyArea: GeoJSON;
  measureConfigurations: MeasureConf[];
  radius: number;
  addNewGeometryToMeasureConfig: (
    newLayer: MeasureConfLayer,
    updatedMeasureConfigs: MeasureConf[]
  ) => void;
}

export const AddNewMarker = memo((props: Props) => {
  const {
    mapRef,
    measureImpact,
    studyArea,
    radius,
    measureConfigurations,
    addNewGeometryToMeasureConfig,
  } = props;

  const [isDrawing, setIsDrawing] = useState<boolean>(true);

  useEffect(() => {
    if (!isDrawing) return;
    function cleanUp() {
      setIsDrawing(true);

      mapRef.pm.disableDraw("Circle");
      mapRef.off("pm:create");
      mapRef.off("pm:drawstart");
    }

    mapRef.on("pm:drawstart", ({ workingLayer }) => {
      workingLayer.on("pm:centerplaced", (e) => {
        //@ts-ignore
        mapRef.pm.Draw.Circle._finishShape(e);
      });
    });

    mapRef.pm.enableDraw("Circle", {
      snappable: false,
      templineStyle: {
        color: measureImpact.measure.color,
        fillOpacity: 1,
      },
      hintlineStyle: {
        color: measureImpact.measure.color,
      },
      pathOptions: {
        ...basePointLayerStyle,
        color: measureImpact.measure.color,
        fillOpacity: 1,
      },
    });

    mapRef.on("pm:create", (event) => {
      const { layer: workingLayer } = event;
      setIsDrawing(false);

      // @ts-ignore
      workingLayer.setRadius(radius);

      const studyAreaGeojson = getGeojsonFeature(studyArea);
      //@ts-ignore
      const isInside = inside(workingLayer.toGeoJSON(), studyAreaGeojson);
      if (!isInside) {
        return workingLayer.remove();
      }
      workingLayer.remove();
      addNewGeometryToMeasureConfig(
        {
          id: Date.now() + Math.random(),
          // @ts-ignore
          geometryLayer: geoJSON(workingLayer.toGeoJSON(), {
            pointToLayer: function (feature, latLng) {
              return circle(latLng, radius);
            },
          }),
        },
        measureConfigurations
      );
      mapRef.removeLayer(workingLayer);
    });

    return function () {
      cleanUp();
    };
  }, [
    mapRef,
    measureImpact,
    measureConfigurations,
    studyArea,
    isDrawing,
    radius,
    addNewGeometryToMeasureConfig,
  ]);
  return null;
});
